export enum SupportedCurrency {
  BRL = 'BRL',
  USD = 'USD',
  EUR = 'EUR',
}
